// extracted by mini-css-extract-plugin
export default {"home":"nav_home__2W59N","svg":"nav_svg__zModY"};